export default __webpack_public_path__ + "static/media/location.b8ef360a.jpg";